'use strict';

/**
 * Konfiguration der Status
 * @class route_states
 * @memberOf v3sWbtPlayerApp:route
 */

angular.module('v3sWbtPlayerApp').config(
    ["$stateProvider", "$urlRouterProvider",  function ($stateProvider, $urlRouterProvider) {
        $stateProvider
        /**
        * Bei der Root-Route (/) werden WBT-Daten geladen, sowie Haupt-Ansicht und Tools definiert
        * @constant 'main'
        * @memberOf v3sWbtPlayerApp:route.route_states
        */
        .state('main', {
            abstract: true,
            url: '',
            views: {
                'wbt-view': {
                    templateUrl: 'app/js/wbt/wbt-view.tpl.html',
                    controller: ["wbt", "v3sNavigationService", "v3sWbtDataService", function (wbt, v3sNavigationService, v3sWbtDataService) {
                        v3sNavigationService.initWbtData(wbt, v3sWbtDataService);
                    }]
                },
                'tool-tree-view': {
                    controller: 'v3sToolTreeCtrl'
                }
            },
            resolve: {
                wbt: ["v3sWbtDataService", function (v3sWbtDataService) {
                    return v3sWbtDataService.load().then(function () {
                        return v3sWbtDataService.getWbt();
                    });
                }]
            }
        })
        /**
        * Bei der SCO-Route (/sco/{scoId}?{entry}) wird ein SCO und ggf. SCO-Eintritt (erste/letzte Seite, Seite mit einer bestimmten ID) referenziert. 
        * SCO-Verhalten wird je nach SCO-Typ definiert: scoStandard, scoStructure, ...
        * @constant 'main.sco'
        * @memberOf v3sWbtPlayerApp:route.route_states
        */
        .state('main.sco', {
            url: '/sco/:scoId?entry&mode',
            params: { readyToChange: false },
            views: {
                'page-view@main': {
                    controller: 'v3sPageCtrl',
                    templateProvider: ["v3sLoaderService", "v3sContentPath", "sco", "page", function (v3sLoaderService, v3sContentPath, sco, page) {
                        return v3sLoaderService(sco.id + '.js', v3sContentPath).then(function (templates) {
                            var template = templates[page.getPath()];
                            if (template) {
                                return template;
                            } else {
                                return '<v3s-document><v3s-timeline></v3s-timeline><v3s-interaction></v3s-interaction><v3s-text id="T05" locked="position" v3s-name="" v3s-left="20" v3s-top="20" v3s-type="head1" v3s-visibility="block" v3s-width="" v3s-title="" v3s-mobile="true" v3s-desktop="true"><v3s-data v3s-textalign="center" v3s-verticalalign="middle"><span class="normalSize">{{"general.filenotavailableincurrentview" | translate}}</v3s-data></v3s-text><v3s-popups></v3s-popups></v3s-document>';
                            }
                        });
                    }]
                },
                'navigation-view@main': {
                    template: '<v3s-navigation page="ctrl.page"></v3s-navigation>',
                    controller: ["page", "v3sNavigationService", function (page, v3sNavigationService) {
                        this.page = page;
                        v3sNavigationService.init(page);
                    }],
                    controllerAs: 'ctrl'
                }
            },
            resolve: {
                sco: ["$stateParams", "wbt", function ($stateParams, wbt) {
                    return wbt.getItem($stateParams.scoId);
                }],
                page: ["$stateParams", "sco", function ($stateParams, sco) {
                    var page = sco.getItem($stateParams.entry);

                    if (!sco.allowEnter(page, false)) {
                        page = null;
                    }

                    return page;
                }]
            }
        })
        /**
        * Die Request-Route (/request/{request}?{entry}) erlabut das Navigieren zwischen SCOs
        * @constant 'main.request'
        * @memberOf v3sWbtPlayerApp:route.route_states
        */
        .state('main.request', {
            url: '/request/:request?entry'
        })
        /**
        * Die Route führt zur Auswahl "mobile Ansicht" auf mobilen Geräten
        * @constant 'mobile'
        * @memberOf v3sWbtPlayerApp:route.route_states
        */
        .state('mobileview', {
            views: {
                'wbt-view': {
                    template: '<v3s-mobile-view-opener v3s-url="{{mobileview.url}}" v3s-cancel="mobileview.cancel"></v3s-mobile-view-opener>'
                }
            }
        });
        $stateProvider
        /**
        * Die Route wird bei Fehlern angezeigt
        * @constant 'error'
        * @memberOf v3sWbtPlayerApp:route.route_states
        */
        .state('error', {
            url: 'error',
            params: { readyToChange: true },
            views: {
                'wbt-view': {
                    template: '<div class="alert alert-warning" role="alert"><b>{{"general.error" | translate}}</b> <p>{{"general.contentLocked" | translate}}</p></div>'
                }
            }
        });

    }]
);